import { render, staticRenderFns } from "./CrmCreate.vue?vue&type=template&id=637db8a0"
import script from "./CrmCreate.vue?vue&type=script&lang=js"
export * from "./CrmCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports